import React, { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Grid,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FastOutgoingMessagesDto } from '../../../types/approval.types';
import { formatMoney, paymentPurpose } from '../../../utils/approvalUtils';

interface FastCancelDetailProps {
  data: FastOutgoingMessagesDto;
  rejectionReason: string;
  onReasonChange: (reason: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
}

const FastCancelDetail: React.FC<FastCancelDetailProps> = ({
  data,
  rejectionReason,
  onReasonChange,
  onSubmit,
  isLoading
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box>
      <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1">İşlem Detayı</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="IBAN"
                value={data.ReceiverIBAN || ''}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="TCKN"
                value={data.ReceiverIdNo || ''}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Alıcı Ad Soyad"
                value={data.ReceiverNameSurname || ''}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Ödeme Nedeni"
                value={paymentPurpose(data.PaymentPurpose || '')}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Tutar"
                value={formatMoney(data.Value)}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Komisyon"
                value={formatMoney(data.ValueFee)}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Toplam"
                value={formatMoney(data.Value + data.ValueFee)}
                disabled
                variant="outlined"
                size="small"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Açıklama"
                value={data.Description}
                disabled
                variant="outlined"
                size="small"
                multiline
                rows={3}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Box sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="İptal Nedeni"
              value={rejectionReason}
              onChange={(e) => onReasonChange(e.target.value)}
              variant="outlined"
              size="small"
              required
              error={!rejectionReason.trim()}
              helperText={!rejectionReason.trim() ? 'Lütfen iptal nedenini giriniz' : ''}
            />
          </Grid>
          
          {/* <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                color="error"
                onClick={onSubmit}
                disabled={!rejectionReason.trim() || isLoading}
              >
                İptal
              </Button>
            </Box>
          </Grid> */}
        </Grid>
      </Box>
    </Box>
  );
};

export default FastCancelDetail;
